import {defineComponent} from "vue";
import InputGroupForm from "@/components/InputGroupForm.vue";
import http from "@/http-common";
import FormSelectVue from "@/components/resultTeam/FormSelectVue.vue";

export default defineComponent({
  components: {FormSelectVue, InputGroupForm},
  props: {
    value: {
      type: Object,
      default: {}
    },
    orgList: [],
    ekpTypeList: [],
    eventKinds: [],
    jobKindList: [],
    kindList: [],
    fedList: [],
    locationList: [],
    eventStateList: [],
    ageKindList: [],
    captionBtnSave: {
      type: String,
      default: 'Сохранить'
    }
  },
  data() {
    return {
      editItem: {
        organizationId: null,
        ageKindId: null,
        eventStateId: null
      },
      limitYear: 0,
      validValue: {
        org: true,
        ekpT: true,
        eventKind: true, // вид ЕКП
        nameEvent: true, // наименование мероприятия
        federation: true, // федерация
        sportKind: true, // раздел ЕКП
        location: true, // место проведения
        jobKind: true, // вид работ
        ageKind: true, // возрастная категория
        summaEkp: true, // сумма
        countPeople: true, // кол-во участников
        summaAll: true,
        summaSmeta: true,
        form: true
      },
      oldSummEkp: 0,
    }
  },
  mounted() {
    this.cleanItem()
    for (let key in this.value) {
      this.editItem[key] = this.value[key];
    }
    for (let key in this.validValue) {
      this.validValue[key] = true;
    }
    if (this.editItem.dateBegin) {
      let datStr = this.editItem.dateBegin;
      let dat = new Date(datStr);
      let year = dat.getFullYear();
      let orgId = this.editItem.organizationId;
      this.loadLimit(year, orgId, this.editItem.ekpTypeId);
      this.loadAllSumm(year, orgId, this.editItem.ekpTypeId);
    }
  },
  watch: {
    'editItem.federationId': function (val) {
      this.updateLimit()
    }
  },
  methods: {
    cleanItem() {
      for (let key in this.editItem) {
        if (typeof this.editItem[key] == 'string') {
          this.editItem[key] = ''
        } else {
          this.editItem[key] = null
        }
      }
    },
    showFiles() {
      this.$emit("showFiles");
      this.showOperation = false;
    },
    closeModal() {
      this.$emit("closeModal")
    },
    updateLimit() {
      let datStr = this.editItem.dateBegin;
      let dat = new Date(datStr);
      let year = dat.getFullYear();
      let orgId = this.editItem.organizationId;
      this.loadLimit(year, orgId, this.editItem.ekpTypeId);
      this.loadAllSumm(year, orgId, this.editItem.ekpTypeId);
    },
    loadLimit(plan_year, orgId, ekpTypeId) {
      var vm = this;
      http.get('/limit/' + plan_year + '/' + orgId + '/' + vm.editItem.sportKindId + '?ekptype_id=' + ekpTypeId)
      .then((response) => {
        vm.limitYear = response.data.summLimit;
      })
      .catch((error) => console.log(error.message));
    },
    checkDat1() {
      var datStr = this.editItem.dateBegin;
      if (this.editItem.dateBegin) {
        var dat = new Date(datStr);
        var year = dat.getFullYear();
        this.loadLimit(year, this.editItem.organizationId, this.editItem.ekpTypeId);
        this.loadAllSumm(year, this.editItem.organizationId, this.editItem.ekpTypeId);
      }
      if (this.editItem.dateBegin > this.editItem.dateEnd && this.editItem.dateEnd) {
        this.editItem.dateEnd = this.editItem.dateBegin
      }
    },
    getLimitInfo() {

    },
    getInfoEkpCreate() {
      let str = '';
      if (this.editItem.cdate || this.editItem.loginC) {
        str = 'создан ';
        if (this.editItem.cdate) {
          str += this.editItem.cdate;
        }
        if (this.editItem.loginC) {
          str += ' ' + this.editItem.loginC;
        }
      }
      return str;
    },
    validSumm(rec) {
      rec.summ = (rec.summ.match(/^\d*(\.?\d{0,2})/g)[0]) || 0
      rec.count_people = Math.floor(rec.count_people) || 0
    },
    loadAllSumm(plan_year, orgId, ekpTypeId) {
      var vm = this;
      http.get('/ekp/allSumm/' + plan_year + '/' + orgId + '?ekptype_id=' + ekpTypeId + '&sportKindId='
          + vm.editItem.sportKindId)
      .then((response) => {
        var dataSum = response.data;
        vm.allSummEkp = parseFloat(dataSum.summEkp);
      })
      .catch((error) => console.log(error.message));
    },
    saveEkp() {
      this.checkForm();
      if (this.validValue.form) {
        let addFlag = false;
        if (!this.editItem.id || this.editItem.id === 0) {
          addFlag = true;
        }
        let vm = this;
        http.post('/ekp', vm.editItem)
        .then((response) => {
          let dataR = response.data;
          if (dataR.id > 0) {
            this.$emit("updateRow", dataR, addFlag)
            this.closeModal()
          } else {
            alert("Ошибка сохранения!!!")
          }
        })
        .catch(error => {
          console.error(error)
          if (error.response.status === 403) {
            alert("Нет прав!")
          } else {
            alert(error.response.message)
          }
        });
      }
    },
    checkForm() {
      let vm = this;
      for (let key in vm.validValue) {
        vm.validValue[key] = true;
      }

      if (vm.nullOrMinus(vm.editItem.organizationId)) {
        this.validValue.org = false;
        this.validValue.form = false;
      }

      if (vm.nullOrMinus(vm.editItem.ekpTypeId)) {
        vm.validValue.ekpT = false;
        vm.validValue.form = false;
      }

      if (vm.nullOrMinus(vm.editItem.eventKindId)) {
        vn.validValue.eventKind = false;
        vm.validValue.form = false;
      }
      if (vm.nullOrMinus(vm.editItem.federationId)) {
        vm.validValue.federation = false;
        vm.validValue.form = false;
      }
      if (vm.nullOrMinus(vm.editItem.sportKindId)) {
        vm.validValue.sportKind = false;
        vm.validValue.form = false;
      }
      if (!vm.editItem.nameEvent || vm.editItem.nameEvent === '') {
        vm.validValue.nameEvent = false;
        vm.validValue.form = false;
      }
      if (vm.nullOrMinus(vm.editItem.locationId)) {
        vm.validValue.location = false;
        vm.validValue.form = false;
      }

      if (vm.nullOrMinus(vm.editItem.jobKindId)) {
        vm.validValue.jobKind = false;
        vm.validValue.form = false;
      }

      if (vm.nullOrMinus(vm.editItem.ageKindId)) {
        vm.validValue.ageKind = false;
        vm.validValue.form = false;
      }

      if (vm.nullOrMinus(vm.editItem.summ)) {
        vm.validValue.summaEkp = false;
        vm.validValue.form = false;
      }
      if (vm.nullOrMinus(vm.editItem.count_people)) {
        vm.validValue.countPeople = false;
        vm.validValue.form = false;
      }
      if (vm.limitYear < vm.allSummEkp + parseFloat(vm.editItem.summ) - vm.oldSummEkp) {
        vm.validValue.summaAll = false;
        vm.validValue.form = false;
      }
      if (vm.editItem.summaSmeta > parseFloat(vm.editItem.summ)) {
        vm.validValue.summaSmeta = false;
        vm.validValue.form = false;
      }
    },
    nullOrMinus(value) {
      return value === undefined || value === null || value < 0
    },
  }
})
